module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA10.bf575386.jpg";